// removed by extract-text-webpack-plugin
module.exports = {"Info":"PressKit__Info__1f0NV","Title":"PressKit__Title__3Fiep","Description":"PressKit__Description__19RiZ","Submenu":"PressKit__Submenu__rjY_9","Actions":"PressKit__Actions__1sfh-","Separator":"PressKit__Separator__1Q5mB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PressKit/PressKit.css
// module id = 242
// module chunks = 0